import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, SparklesIcon } from 'lucide-react';
const HERO_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/7caee9f3-ea89-417f-a689-c948755e4146.jpg';
export function Hero() {
  return <section className="relative w-full min-h-[92vh] flex items-center overflow-hidden" data-id="element-55" data-mp="9l37jlcn0s87">
      <img src={HERO_IMG} alt="Decoración de cumpleaños con arco de globos rosa, lila y dorado" className="absolute inset-0 h-full w-full object-cover" data-id="element-56" data-mp="4njqyesgw3d3" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#2f2a33]/85 via-[#2f2a33]/55 to-transparent" data-id="element-57" data-mp="xbpaiy7sbmbc" />

      <div className="relative mx-auto w-full max-w-6xl px-6 py-24" data-id="element-58" data-mp="s9q8brns6vfz">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} className="max-w-2xl text-white" data-id="element-59" data-mp="nczrh245jvti">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-sm font-medium backdrop-blur" data-id="element-60" data-mp="380vyhwiiarcm">
            <SparklesIcon className="h-4 w-4 text-[#f4d160]" data-id="element-61" data-mp="3j6od1nctwsro" />
            Curso online de decoración con globos
          </span>

          <h1 className="font-display mt-6 text-4xl font-semibold leading-[1.08] sm:text-5xl lg:text-6xl" data-id="element-62" data-mp="39aur5dd7zmx8">
            Aprendé a decorar con globos y convertilo en tu negocio
          </h1>

          <p className="mt-6 max-w-xl text-lg text-white/85 sm:text-xl" data-id="element-63" data-mp="30iawsp3yo4i7">
            Creá decoraciones profesionales para cumpleaños y eventos, desde
            cero y a tu ritmo.
          </p>

          <div className="mt-9 flex flex-col gap-4 sm:flex-row sm:items-center" data-id="element-64" data-mp="2qk3mgp46gkp6">
            <a href="https://curso-de-decoracion-con-globos-para-cumpleanos-y-eventos.impultienda.ar/checkout" className="group inline-flex items-center justify-center rounded-full bg-[#ec4899] px-9 py-4 text-base font-semibold text-white shadow-lg shadow-[#ec4899]/40 transition hover:bg-[#db2777] hover:shadow-xl" data-id="element-65" data-mp="2qi0o9hsvfl9d">
              QUIERO EMPEZAR AHORA
            </a>

            <div className="flex items-center gap-3" data-id="element-66" data-mp="nbba6qtxtx1l">
              <div className="flex text-[#f4d160]" data-id="element-67" data-mp="n9qjxdenp09j">
                {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-current" data-id="element-68" data-mp="ia5imwc0kftn" data-mpi={i} />)}
              </div>
              <p className="text-sm text-white/85" data-id="element-69" data-mp="db2fjhflgjob">
                Más de <strong className="text-white" data-id="element-70" data-mp="1azktnm3oi8pk">500 alumnas</strong> ya
                decoraron su primer evento
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}